// const errorType1 = {
//   data: {
//     cfaCredentials: {
//       nonFieldErrors: [
//         '여신금융협회 로그인에 실패했습니다. 아이디/비밀번호를 다시 확인해주세요.',
//       ],
//     },
//   },
// }
// const errorType2 = {
//   data: {
//     message: '거래가 불가능한 계좌입니다.',
//     errors: [
//       {
//         message: '거래가 불가능한 계좌입니다.',
//       },
//     ],
//   },
// }

const errorParser = (err) => {
  const data = err?.data

  let message = null
  let messages = []

  messages = extractErrors(data)
  message = messages[0]

  return {
    message,
    messages,
  }
}

function extractErrors(errorObject) {
  const errorStrings = []

  function findStrings(obj) {
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        errorStrings.push(obj[key])
      } else if (typeof obj[key] === 'object') {
        findStrings(obj[key])
      } else if (Array.isArray(obj[key])) {
        obj[key].forEach((item) => {
          if (typeof item === 'string') {
            errorStrings.push(item)
          } else if (typeof item === 'object') {
            findStrings(item)
          }
        })
      }
    }
  }

  findStrings(errorObject)

  return errorStrings
}

export const setError = (err) => {
  const msg = errorParser(err)
  const newErr = { ...err, ...msg }
  return newErr
}

export default { setError }
